import React from 'react';
import { ROLES, ROLE_COLORS, ROLE_LABELS } from './utils/roleUtils';

/**
 * User Profile Card
 * 
 * Shows avatar, name, email, and role badge(s).
 * Admin users get a highlighted border.
 * Multi-role users show multiple role badges.
 */
export default function MobileNavUserCard({
  initials,
  displayName,
  email,
  role,
  roleLabel,
  colors,
  taps,
  allRoles, // New prop: array of all dashboard roles for multi-role users
}) {
  // Admin gets special border treatment
  const isAdmin = role === ROLES.ADMIN;
  const cardClasses = isAdmin
    ? `bg-gradient-to-r ${colors.bgLight} border ${colors.border}`
    : 'bg-white/5 border border-white/10';
  
  return (
    <div className={`rounded-2xl p-4 mb-6 ${cardClasses}`}>
      <div className="flex items-center gap-3">
        {/* Avatar */}
        <div className={`w-12 h-12 bg-gradient-to-br ${colors.gradient} rounded-full flex items-center justify-center text-white font-bold text-lg`}>
          {initials}
        </div>
        
        {/* Name & Email */}
        <div className="flex-1 min-w-0">
          <div className="font-semibold text-white truncate">{displayName}</div>
          <div className="text-xs text-white/50 truncate">{email}</div>
        </div>
        
        {/* Multi-Role Badges or Single Role Badge or Taps */}
        {allRoles && allRoles.length > 1 ? (
          <div className="flex flex-wrap gap-1 justify-end max-w-[120px]">
            {allRoles.map((r) => {
              const roleColors = ROLE_COLORS[r];
              const label = ROLE_LABELS[r];
              return (
                <div key={r} className={`px-2 py-0.5 rounded-full ${roleColors.badge}`}>
                  <span className="text-[10px] font-medium">{label}</span>
                </div>
              );
            })}
          </div>
        ) : roleLabel ? (
          <div className={`px-2 py-1 rounded-full ${colors.badge}`}>
            <span className="text-xs font-medium">{roleLabel}</span>
          </div>
        ) : taps !== undefined ? (
          <div className="text-right">
            <div className="flex items-center gap-1 text-orange-400">
              <span className="text-lg font-bold">{taps}</span>
              <span className="text-xs">Taps</span>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}
